<template>
    <transition name="fade" mode="out-in">
        <div class="card mb-3" v-if="resource.ready">
            <div class="card-title" v-once>
                <span>Настройки воронок CRM</span>
            </div>

            <form class="spaced-y-4" @submit.prevent="submit">
                <p class="text-gray-800 font-medium mb-2">Статусы</p>

                <div class="flex -mx-2" v-for="status in statuses" :key="status.amo_id">
                    <text-field class="w-1/3 px-2" v-bind:value="status.name" disabled />

                    <div class="w-1/3 px-2">
                        <label class="flex mt-2">
                            <input
                                type="checkbox"
                                class="form-checkbox mt-1"
                                @input="setOnCreate(status)"
                                v-model="status.on_create"
                            />

                            <div class="ml-2">
                                <div
                                    class="text-gray-800 text-gray-700 text-sm tracking-wider"
                                >Создание заказов</div>
                            </div>
                        </label>
                    </div>

                    <div class="w-1/3 px-2">
                        <label class="flex mt-2">
                            <input
                                type="checkbox"
                                class="form-checkbox mt-1"
                                @input="setOnPaid(status)"
                                v-model="status.on_paid"
                            />

                            <div class="ml-2">
                                <div
                                    class="text-gray-800 text-gray-700 text-sm tracking-wider"
                                >Оплата заказа</div>
                            </div>
                        </label>
                    </div>
                </div>

                <hr class="mb-3" />

                <p class="text-gray-800 font-medium mb-2">Воронки</p>

                <div class="flex -mx-2" v-for="pipeline in pipelines" :key="pipeline.id">
                    <text-field class="w-1/3 px-2" v-model="pipeline.name" disabled />

                    <div class="w-1/3 px-2">
                        <label class="flex mt-2">
                            <input
                                type="checkbox"
                                class="form-checkbox mt-1"
                                @input="setPipeline(pipeline)"
                                v-model="pipeline.is_active"
                            />

                            <div class="ml-2">
                                <div
                                    class="text-gray-800 text-gray-700 text-sm tracking-wider"
                                >Активна</div>
                            </div>
                        </label>
                    </div>
                </div>

                <hr class="mb-3" />

                <button class="btn btn-primary">Сохранить</button>
            </form>
        </div>
    </transition>
</template>

<script>
export default {
    data() {
        return {
            resource: {
                endpoint: "admin/crm/settings",
                ready: false
            },

            pipelines: [],
            statuses: []
        };
    },

    methods: {
        fetch() {
            axios.get("admin/crm/settings").then(response => {
                this.pipelines = response.data.data.pipelines;
                this.statuses = response.data.data.statuses;
                this.resource.ready = true;
            });
        },

        setOnPaid(chosenStatus) {
            this.statuses
                .filter(status => status != chosenStatus)
                .forEach(function(status) {
                    status.on_paid = false;
                });
        },

        setOnCreate(chosenStatus) {
            this.statuses
                .filter(status => status != chosenStatus)
                .forEach(function(status) {
                    status.on_create = false;
                });
        },

        setPipeline(chosenPipeline) {
            this.pipelines
                .filter(pipeline => pipeline != chosenPipeline)
                .forEach(function(pipeline) {
                    pipeline.is_active = false;
                });

            let inactivePipelines = this.pipelines.filter(
                pipeline => pipeline.is_active === false
            ).length;
        },

        submit() {
            axios
                .put("/admin/crm/settings", {
                    pipelines: this.pipelines,
                    statuses: this.statuses
                })
                .then(response => {
                    this.$message.success("Данные сохранены");
                });
        }
    },

    mounted() {
        this.fetch();
    }
};
</script>